import { CircularProgress } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useProductByIdQuery } from '../../api/hooks/products';
import { Formik } from 'formik';
import {
  ProductCreateWithVariants,
  ProductUpdateWithVariants,
} from 'src/app/api/openapi';
import CreateProductForm from './CreateProductForm';
import { ProductClient } from 'src/app/api/clients/products';
import { uploadMediaForProduct } from 'src/app/api/hooks/media';

const EditProduct = () => {
  const { state } = useLocation();
  const { orgId, productId } = useParams();
  const navigate = useNavigate();
  const { data, isLoading: isLoadingProduct } = useProductByIdQuery(
    {
      orgId,
      productId,
    },
    { enabled: !state }
  );

  const product: ProductCreateWithVariants | ProductUpdateWithVariants =
    state || data;

  const handleUpdateProduct = (
    values: ProductCreateWithVariants | ProductUpdateWithVariants
  ) => {
    if (!orgId) return alert("Can't update product. Missing organization ID.");
    if (!productId) return alert("Can't update product. missing product ID.");
    // @ts-ignore
    const { filesToUpload, ...updatedProduct } = values;
    if (updatedProduct.has_adult_consideration === 'null')
      delete updatedProduct.has_adult_consideration;
    ProductClient.updateProduct(
      orgId,
      productId,
      updatedProduct as ProductUpdateWithVariants
    ).then(({ data: product }) => {
      if (!filesToUpload) return navigate(`/products/${orgId}/${product.id}`);
      uploadMediaForProduct(orgId, product.id, filesToUpload).then(() =>
        navigate(`/products/${orgId}/${product.id}`)
      );
    });
  };

  if (isLoadingProduct) return <CircularProgress />;

  return (
    <Formik initialValues={product} onSubmit={handleUpdateProduct}>
      {CreateProductForm}
    </Formik>
  );
};

export default EditProduct;
